import React from 'react';
import { Navigate } from 'react-router-dom';
import { Card, Typography, Button } from 'antd';
import { SafetyOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import { UserRole } from '../types/admin.types';
import { AdminLoginForm } from '../components/auth/AdminLoginForm';

const { Title, Text } = Typography;

export const AdminLoginPage: React.FC = () => {
    const { user, isLoading } = useAuth();

    // Если пользователь уже авторизован и является админом/модератором
    if (!isLoading && user) {
        if ([UserRole.MODERATOR, UserRole.SIGNATORY, UserRole.SUPER_ADMIN].includes(user.role as UserRole)) {
            return <Navigate to="/admin/moderation" replace />;
        } else {
            return <Navigate to="/dashboard" replace />;
        }
    }

    const handleAdminSuccess = () => {
        // Форма сама обновит контекст через login()
        console.log('Админ успешно авторизован');
    };

    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
            <Card className="w-full max-w-md shadow-lg">
                <div className="text-center mb-8">
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4">
                        <SafetyOutlined className="text-2xl text-blue-600" />
                    </div>
                    <Title level={2} className="mb-2">
                        Админ-панель "AISER"
                    </Title>
                    <Text type="secondary">
                        Вход для модераторов и администраторов
                    </Text>
                </div>

                <AdminLoginForm onSuccess={handleAdminSuccess} />

                <div className="text-center space-y-2 mt-6">
                    <Text type="secondary" className="text-sm">
                        Доступ только для авторизованного персонала
                    </Text>
                    <div>
                        <Button type="link" size="small" href="/auth">
                            Вход для клиентов
                        </Button>
                    </div>
                </div>
            </Card>
        </div>
    );
};
